import RolesTable from '@/app/roles'
import { ability } from '@/casl/ability'
import TableSkeleton from '@/components/table-skeleton'
import { getFirstAccessibleRoute } from '@/constants/Auth'
import { rolesQueryOptions } from '@/hooks/useRolesQuery'
import LocalStorage from '@/utilities/LocalStorage'
import { redirect } from '@tanstack/react-router'
import { createFileRoute } from '@tanstack/react-router'

const RouteComponent = () => {
  return <RolesTable />
}

export const Route = createFileRoute('/_auth/_withProject/roles')({
  beforeLoad: ({ context }) => {
    if (ability && context.auth.user && !ability.can('read', 'Rol')) {
      const permissions = context.auth.user.permissions || []
      const redirectPath = getFirstAccessibleRoute(permissions)
      throw redirect({
        to: redirectPath,
      })
    }
  },
  loader: async ({ context }) => {
    const { queryClient } = context
    const companyId = LocalStorage.selectedCompany()?.id

    await queryClient.prefetchQuery(rolesQueryOptions(companyId))
    return {}
  },
  pendingComponent: TableSkeleton,
  component: RouteComponent,
})